import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowSpinLeft32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconArrowSpinLeft32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M27.368 27.443a1.2 1.2 0 0 1-2.4 0v-.823c-.976.935-2.221 1.67-3.467 2.2-2.337.992-5.11 1.46-7.26 1.085-3.89-.679-6.467-2.178-7.48-3.188a1.2 1.2 0 0 1 1.696-1.7c.57.569 2.643 1.904 6.197 2.524 1.574.274 3.87-.064 5.909-.93 1.439-.612 2.55-1.397 3.21-2.228l-1.81.346a1.2 1.2 0 0 1-.45-2.358l4.43-.847 1.425-.271zM16.003 10.445c3.084 0 5.585 2.5 5.585 5.583l-.008.288a5.585 5.585 0 0 1-5.577 5.296l-.287-.006a5.584 5.584 0 0 1 .287-11.16m0 2.4a3.183 3.183 0 1 0 0 6.367 3.183 3.183 0 0 0 0-6.366M10.53 3.238c2.337-.992 5.11-1.46 7.26-1.086 3.89.68 6.467 2.179 7.48 3.189a1.2 1.2 0 0 1-1.696 1.7c-.57-.57-2.643-1.904-6.197-2.524-1.573-.275-3.87.064-5.908.93-1.44.612-2.55 1.397-3.21 2.228l1.81-.346a1.2 1.2 0 1 1 .45 2.358l-4.431.846-1.425.272v-6.19a1.2 1.2 0 1 1 2.4 0v.823c.977-.936 2.221-1.67 3.467-2.2"
            />
        </svg>
    );
}
export default memo(IconArrowSpinLeft32);
